<template>
  <!-- eslint-disable max-len -->
  <div>
    <main class="instant-savings-desktop u-container u-no-print">
      <h1 class="font-bold">
        USPS Change-of-Address<sup>®</sup>
      </h1>
      <IndividualProgressBarWithSteps
        v-if="showSimplifyExperience"
        :mobile="false"
      />
      <IndividualProgressBar
        v-if="!showSimplifyExperience"
        role="progressbar"
        :aria-valuenow="progressStep"
        :aria-valuemin="0"
        :aria-valuemax="1"
      />
      <div class="mt-8">
        <h2 ref="stepHeading">
          <template v-if="!showChoiceExperience && !isDesktop">
            Step 4:&nbsp;
          </template>
          <span class="font-bold">Would you like to receive special offers?</span>
        </h2>
        <p class="mt-4">
          Select "Yes" to get all the offers below delivered to <strong v-if="email">{{ email }}</strong><strong v-else>the email provided</strong> in a
          <strong>one-time email from USPS</strong> 
          <br>after you complete your USPS Change-of-Address.
        </p>
      </div>
      <form
        ref="form"
        novalidate
        @submit.prevent="submit"
      >
        <div class="flex mt-6">
          <button
            id="offers-yes-btn"
            ref="offersYesBtn"
            type="button"
            :class="{ 'c-btn--secondary': offersOptIn !== 'YES' }"
            class="c-btn"
            @click="selectOffersOptIn('YES')"
          >
            Yes
          </button>
          <button
            id="offers-no-btn"
            ref="offersNoBtn"
            type="button"
            :class="{ 'c-btn--secondary': offersOptIn !== 'NO' }"
            class="c-btn ml-6"
            @click="selectOffersOptIn('NO')"
          >
            No
          </button>
        </div>
        <p
          v-if="offersOptInError"
          class="errors text-red-200 text-sm font-bold mt-2"
        >
          Please make a selection.
        </p>
        <div class="c-hairline mt-8" />
        <div
          v-if="offers && offers.length"
          class="flex flex-wrap mt-8"
        >
          <component
            :is="getAmpComponent(template.schema.name)"
            v-for="({ accountId, accountName, adGroupId, id, template }, objectId) in offers"
            ref="offerTile"
            :key="id"
            :value="selectedOffers.includes(offers[objectId])"
            :account-id="accountId"
            :account-name="accountName"
            :ad-id="id"
            :ad-group-id="adGroupId"
            :alt-text="accountName"
            :background-url="template.properties.backgroundUrl"
            :cta="template.properties.cta"
            :headline="template.properties.headline"
            :legal-text="template.properties.legalText"
            :logo-url="template.properties.logoUrl"
            :short-description="template.properties.shortDescription"
            :tooltip="template.properties.tooltip"
            :template-id="template.id"
            class="instant-savings-desktop__offer-tile disable-hover"
            @selected:offer="toggleOfferSelect(offers[objectId])"
          />
        </div>
        <p class="w-2/3 mt-8 text-sm">
          Neither the U.S. Postal Service<sup>®</sup> nor any contractor associated with the operation of this website: (1) make any guarantee as to the accuracy of the statements made by the advertisers or the content of the editorial material on this website; (2) endorse any company, product or service listed or advertised in this MoversGuide Online™ product; (3) will be held liable in any manner for any claim, loss, expense, damage or consumer dissatisfaction arising out of or in connection with the use of the MoversGuide Online<sup>™</sup> product; and (4) the advertising materials are free to the public and produced without the use of either tax or postal revenue.
        </p>
        <div class="c-hairline mt-8" />
        <button
          id="next-btn"
          ref="nextBtn"
          class="c-btn mt-6"
          :class="{ 'c-btn--disabled': !offersOptIn }"
          @click="analytics.click.next($route.params.orderUuid)"
        >
          Next
        </button>
        <section class="py-8">
          <PrivacyActStatement class="w-2/3" />
        </section>
      </form>
    </main>
  </div>
</template>

<script>
import {
  AdvantageDouble,
  AdvantageSingle,
} from '@ampersend/mgo';
import {
  IndividualProgressBarWithSteps,
  IndividualProgressBar,
} from '@mgo/ui/lib/components';
import { isDesktop } from '../../utils/deviceType';
import { desktopAnalytics } from './analytics';
import InstantSavingsMixin from './mixin';
import PrivacyActStatement from '../../components/PrivacyActStatement.vue';

export default {
  name: 'DesktopInstantSavings',
  components: {
    AdvantageDouble,
    AdvantageSingle,
    IndividualProgressBarWithSteps,
    IndividualProgressBar,
    PrivacyActStatement,
  },
  mixins: [InstantSavingsMixin],
  computed: {
    isDesktop,
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    analytics() {
      return desktopAnalytics();
    },
    schemaNames() {
      return ['MGO Advantage Double', 'MGO Advantage Single'];
    },
  },
};
</script>
